/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Work_Order_Import_FailedInputs */



/**
* | output |
* | --- |
* | "External Work Order Import Failed. {message}" |
*
* @param {Work_Order_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_failed = /** @type {((inputs: Work_Order_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l’importation de l’ordre de travail externe. ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Import externer Arbeitsaufträge fehlgeschlagen. ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Importazione ordine di lavoro esterno non riuscita. ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Импорт внешнего заказа на выполнение работ не удался. ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en la importación de la orden de trabajo externa. ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`外部工单导入失败。${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`外部作業指示書のインポートに失敗しました。${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`बाह्य कार्य आदेश आयात विफल। ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A importação da ordem de serviço externa falhou. ${i?.message}`)
	return /** @type {LocalizedString} */ (`External Work Order Import Failed. ${i?.message}`)
});